import SmtpSettingPanel from "./smtpSettingPanel.container";

export default SmtpSettingPanel;
